import { c as _c } from "react/compiler-runtime";
import { Typography } from '@mui/material';
import type { ReactNode } from 'react';
export const GroupTitle = t0 => {
  const $ = _c(5);
  const {
    title,
    hideBackground
  } = t0;
  const t1 = hideBackground ? undefined : "var(--mui-palette-background-section)";
  let t2;
  if ($[0] !== t1) {
    t2 = {
      display: "block",
      padding: "8px 24px",
      marginY: "12px",
      backgroundColor: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2 || $[3] !== title) {
    t3 = <Typography variant="overline" className="w-full cursor-default" sx={t2}>{title}</Typography>;
    $[2] = t2;
    $[3] = title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};